import { useState } from "react";

import { useCallContext } from "../Call/CallContext";
import { CallResultsCoaching } from "./CallResultsCoaching";
import { CallResultsReportTabs, type ReportTab } from "./CallResultsReportTabs";
import { CallSummary } from "./CallSummary";

export const CallResultsReport = () => {
  const { handleRequestSummary, summary } = useCallContext();
  const [activeTab, setActiveTab] = useState<ReportTab>("coaching");
  return (
    <div className="w-full bg-slate-50 p-4">
      <div className="items flex w-full flex-grow flex-col space-y-4">
        <div className="flex flex-row items-center space-x-4">
          <CallResultsReportTabs
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
        </div>
        {activeTab === "coaching" && <CallResultsCoaching />}
        {activeTab === "summary" && (
          <CallSummary
            handleRequestSummary={handleRequestSummary}
            summary={summary}
          />
        )}
      </div>
    </div>
  );
};
